//ja.js
import jpLocale from 'element-ui/lib/locale/lang/ja'
import jpJson from '../locales/jp.json'
const jp = {
    ...jpJson['jp'],
    ...jpLocale
}

export default jp